import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../services/api';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const submit = async (event) => {
    event.preventDefault();
    setError('');
    setMessage('');
    if (password !== confirmPassword) {
      setError('Passwords must match.');
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post('/auth/reset-password', {
        token: searchParams.get('token'),
        password,
      });
      setMessage(data.message || 'Password reset successfully.');
    } catch (err) {
      setError(err?.response?.data?.error || 'Password reset failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center px-4">
      <div className="w-full max-w-lg rounded-3xl bg-white p-8 shadow-xl">
        <h1 className="text-2xl font-bold text-slate-900">Create New Password</h1>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <input type="password" value={password} onChange={(event) => setPassword(event.target.value)} placeholder="New password" className="w-full rounded-2xl border border-slate-300 px-4 py-3 outline-none focus:border-indigo-500" required />
          <input type="password" value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} placeholder="Confirm new password" className="w-full rounded-2xl border border-slate-300 px-4 py-3 outline-none focus:border-indigo-500" required />
          <button disabled={loading} className="w-full rounded-2xl bg-indigo-600 px-4 py-3 font-semibold text-white disabled:opacity-60">
            {loading ? 'Saving...' : 'Reset password'}
          </button>
        </form>
        {message ? <div className="mt-4 rounded-2xl bg-emerald-50 p-3 text-sm text-emerald-700">{message}</div> : null}
        {error ? <div className="mt-4 rounded-2xl bg-rose-50 p-3 text-sm text-rose-700">{error}</div> : null}
        <Link to="/login" className="mt-5 inline-block text-sm font-semibold text-indigo-700">Back to login</Link>
      </div>
    </div>
  );
}
